<template>
  <div>
    <!-- <Navbar /> -->
    <a-card :bordered="false" class="import-card">
      <div class="page-title">IMPORT VOUCHER</div>
      <div class="page-subtitle">
        Chỉ tài khoản MANAGER được phép import voucher vào kho.
      </div>

      <a-alert
        v-if="Result.Message"
        :type="
          Result.State === 1
            ? Result.Failed > 0
              ? 'warning'
              : 'success'
            : 'error'
        "
        :message="Result.Message"
        :description="Result.Failed_Note || undefined"
        show-icon
        closable
        class="result-alert"
      />

      <a-form-model
        ref="ImportForm"
        :model="Form"
        :rules="Rules"
        layout="vertical"
      >
        <a-row :gutter="20" class="import-form-grid">
          <!-- Cột trái: chỉ chọn file -->
          <a-col :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
            <div class="file-panel">
              <a-form-model-item label="File Excel" prop="File">
                <a-upload
                  :file-list="FileList"
                  :before-upload="BeforeUpload"
                  :remove="RemoveFile"
                  :multiple="false"
                  accept=".xlsx"
                >
                  <a-button
                    type="primary"
                    icon="upload"
                    class="select-file-button"
                  >
                    CHỌN FILE VOUCHER
                  </a-button>
                </a-upload>

                <div class="field-help file-help">
                  Hỗ trợ:
                  VoucherCodes_&lt;Batch_Number&gt;_YYYYMMDD_HHmmss.xlsx
                  hoặc Shopee_PLS_Request_&lt;Number&gt;_DDMMYYYY.xlsx
                </div>
              </a-form-model-item>
            </div>
          </a-col>

          <!-- Cột phải: toàn bộ cấu hình import -->
          <a-col :xl="16" :lg="16" :md="24" :sm="24" :xs="24">
            <div class="import-config-panel">
              <a-row :gutter="12">
                <a-col :xl="14" :lg="14" :md="14" :sm="24" :xs="24">
                  <a-form-model-item label="Batch Number" class="compact-form-item">
                    <a-input
                      v-model="Form.Batch_Number"
                      disabled
                      placeholder="Tự tách từ filename"
                    />
                  </a-form-model-item>
                </a-col>

                <a-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24">
                  <a-form-model-item
                    label="Mệnh giá"
                    prop="Value"
                    class="compact-form-item"
                  >
                    <a-select v-model="Form.Value" style="width: 100%">
                      <a-select-option :value="500000">500.000</a-select-option>
                      <a-select-option :value="1000000">1.000.000</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="12">
                <a-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
                  <a-form-model-item
                    label="Password file"
                    class="compact-form-item"
                  >
                    <a-input-password
                      v-model="Form.Password"
                      autocomplete="new-password"
                      placeholder="Nếu có"
                    />
                  </a-form-model-item>
                </a-col>

                <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-model-item
                    label="Ngày hết hạn"
                    prop="Expired_Date"
                    class="compact-form-item"
                  >
                    <a-input
                      v-model.trim="Form.Expired_Date"
                      placeholder="VD: 1/1/2027, 2027-01-01, 2027/01/01, 1-1-2027"
                      @blur="NormalizeExpiredDate"
                    >
                      <a-icon slot="suffix" type="calendar" />
                    </a-input>
                  </a-form-model-item>
                </a-col>

                <a-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
                  <a-form-model-item
                    label="Nhà cung cấp"
                    prop="Providor"
                    class="compact-form-item"
                  >
                    <a-input
                      v-model.trim="Form.Providor"
                      :max-length="200"
                      placeholder="SPE"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>

        <div class="filename-preview" v-if="Form.File_Name">
          <div><b>Filename:</b> {{ Form.File_Name }}</div>
          <div><b>Batch Number:</b> {{ Form.Batch_Number || "-" }}</div>
          <div><b>Timestamp file:</b> {{ Form.File_Timestamp || "-" }}</div>
          <div>
            <b>Unix timestamp:</b> {{ Form.File_Unix_Timestamp || "-" }}
          </div>
          <div v-if="Form.Batch_Number && Form.File_Timestamp">
            <b>Voucher_ID mẫu:</b>
            {{ Form.Batch_Number }}_{{ Form.File_Unix_Timestamp }}_1
          </div>
        </div>

        <div class="action-row">
          <a-button
            type="primary"
            icon="import"
            :loading="Loading.Import"
            @click="SubmitImport"
          >
            IMPORT VOUCHER
          </a-button>
        </div>
      </a-form-model>
    </a-card>

    <a-card :bordered="false" class="history-card">
      <div class="history-header">
        <div>
          <div class="section-title">LỊCH SỬ IMPORT</div>
          <div class="section-subtitle">
            File gốc có thể tải lại từ lịch sử.
          </div>
        </div>
        <a-button icon="reload" :loading="Loading.History" @click="LoadHistory">
          TẢI LẠI
        </a-button>
      </div>

      <a-table
        :columns="Columns"
        :data-source="History.Items"
        :row-key="(Record) => Record._id"
        :loading="Loading.History"
        :pagination="false"
        :scroll="{ x: 1500 }"
        size="middle"
      >
        <template slot="Expired_Date" slot-scope="Value, Record">
          <a-tag color="orange">{{ Record.Providor }}</a-tag
          ><a-tag color="green">{{ FormatMoney(Record.Value) }}đ</a-tag
          ><br /><a-tag color="blue">{{ FormatDate(Value) }}</a-tag>
        </template>
        <template slot="result" slot-scope="Text, Record">
          <a-tag v-if="Record && Number(Record.Success) > 0" color="green"
            >{{ Record.Success }} OK</a-tag
          >
          <a-tag v-if="Record.Failed" color="red"
            >{{ Record.Failed }} FAIL</a-tag
          >
        </template>

        <template slot="failedNote" slot-scope="Text">
          <a-tooltip v-if="Text" :title="Text">
            <span class="failed-note">{{ Text }}</span>
          </a-tooltip>
          <span v-else>-</span>
        </template>

        <template slot="download" slot-scope="Text, Record">
          <a-button
            type="link"
            icon="download"
            @click="DownloadHistory(Record)"
          >
            TẢI FILE
          </a-button>
        </template>
      </a-table>

      <div class="pagination-row">
        <a-pagination
          :current="History.Page"
          :page-size="History.PageSize"
          :total="History.Total"
          :show-size-changer="true"
          :page-size-options="['10', '30', '50', '100']"
          show-quick-jumper
          @change="ChangePage"
          @showSizeChange="ChangePageSize"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
// import Navbar from "@/components/Navbar.vue";
import moment from "moment";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "VoucherImport",
  components: {
    // Navbar,
  },
  computed: {
    ...mapState(["oUser"]),
  },
  data() {
    return {
      Loading: {
        Import: false,
        History: false,
      },

      FileList: [],

      Form: {
        File: null,
        File_Name: "",
        Batch_Number: "",
        File_Timestamp: "",
        File_Unix_Timestamp: "",
        Expired_Date: null,
        Password: "",
        Value: 500000,
        Providor: "SPE",
      },

      Result: {
        State: null,
        Message: "",
        Failed: 0,
        Failed_Note: "",
      },

      Rules: {
        File: [
          {
            required: true,
            message: "Vui lòng chọn file Excel.",
            trigger: "change",
          },
        ],
        Expired_Date: [
          {
            required: true,
            message: "Vui lòng nhập ngày hết hạn.",
            trigger: ["blur", "change"],
          },
          {
            validator: (Rule, Value, Callback) => {
              if (!Value) {
                Callback();
                return;
              }

              const Parsed = this.ParseExpiredDate(Value);

              if (!Parsed) {
                Callback(
                  new Error(
                    "Ngày không hợp lệ. Hỗ trợ: D/M/YYYY, YYYY-MM-DD, YYYY/MM/DD, D-M-YYYY.",
                  ),
                );
                return;
              }

              if (Parsed.isBefore(moment().startOf("day"))) {
                Callback(new Error("Ngày hết hạn không được nhỏ hơn hôm nay."));
                return;
              }

              Callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        Value: [
          {
            required: true,
            message: "Vui lòng chọn mệnh giá.",
            trigger: "change",
          },
        ],
        Providor: [
          {
            required: true,
            message: "Vui lòng nhập nhà cung cấp.",
            trigger: "blur",
          },
        ],
      },

      History: {
        Items: [],
        Total: 0,
        Page: 1,
        PageSize: 30,
      },

      Columns: [
        {
          title: "THỜI GIAN",
          dataIndex: "Created_At",
          width: 150,
          customRender: this.FormatDateTime,
        },
        { title: "FILE", dataIndex: "Filename", width: 320 },
        { title: "BATCH", dataIndex: "Batch_Number", width: 150 },
        { title: "USER", dataIndex: "Username", width: 100 },
        {
          title: "THÔNG TIN VOUCHER",
          dataIndex: "Expired_Date",
          width: 150,
          scopedSlots: { customRender: "Expired_Date" },
          // customRender: this.FormatDate,
        },
        // {
        //   title: "MỆNH GIÁ",
        //   dataIndex: "Value",
        //   width: 120,
        //   scopedSlots: { customRender: "value" },
        // },
        // { title: "PROVIDOR", dataIndex: "Providor", width: 150 },
        { title: "TOTAL", dataIndex: "Total", width: 80 },
        {
          title: "KẾT QUẢ",
          key: "Result",
          width: 150,
          scopedSlots: { customRender: "result" },
        },
        {
          title: "FAILED NOTE",
          dataIndex: "Failed_Note",
          width: 300,
          scopedSlots: { customRender: "failedNote" },
        },
        {
          title: "",
          key: "Download",
          fixed: "right",
          width: 110,
          scopedSlots: { customRender: "download" },
        },
      ],
    };
  },

  created() {
    this.CheckManager();
    this.LoadHistory();
  },

  methods: {
    GetToken() {
      console.log(this.oUser.Token);
      return this.oUser && this.oUser.Token ? this.oUser.Token : "";
    },

    GetRole() {
      return String(
        (this.$store &&
          this.$store.state &&
          this.$store.state.user &&
          this.$store.state.user.Role) ||
          localStorage.getItem("Role") ||
          "",
      ).toUpperCase();
    },

    CheckManager() {
      if (this.GetRole() && this.GetRole() !== "MANAGER") {
        this.$message.error(
          "Bạn không có quyền truy cập chức năng Import Voucher.",
        );
      }
    },

    ParseFilename(FileName) {
      const sBaseName = String(FileName || "").replace(/\.[^.]+$/, "");

      /*
       * Format cũ:
       * VoucherCodes_<Batch_Number>_YYYYMMDD_HHmmss.xlsx
       */
      const VoucherCodesMatch =
        /^VoucherCodes_(.+)_(\d{8}_\d{6})$/i.exec(sBaseName);

      if (VoucherCodesMatch) {
        const FileTimestamp = String(
          VoucherCodesMatch[2] || "",
        ).trim();

        const ParsedTimestamp = moment(
          FileTimestamp,
          "YYYYMMDD_HHmmss",
          true,
        );

        if (!ParsedTimestamp.isValid()) {
          return null;
        }

        return {
          Batch_Number: String(
            VoucherCodesMatch[1] || "",
          ).trim(),
          File_Timestamp: FileTimestamp,
          File_Unix_Timestamp: ParsedTimestamp.unix(),
        };
      }

      /*
       * Format Shopee PLS:
       * Shopee_PLS_Request_<Number>_DDMMYYYY.xlsx
       *
       * VD:
       * Shopee_PLS_Request_585_04092026.xlsx
       * => Batch_Number: PLS_585_04092026
       */
      const ShopeePLSMatch =
        /^Shopee_PLS_Request_(\d+)_(\d{8})$/i.exec(sBaseName);

      if (ShopeePLSMatch) {
        const RequestNumber = String(
          ShopeePLSMatch[1] || "",
        ).trim();

        const FileDate = String(
          ShopeePLSMatch[2] || "",
        ).trim();

        const ParsedDate = moment(
          FileDate,
          "DDMMYYYY",
          true,
        );

        if (!ParsedDate.isValid()) {
          return null;
        }

        return {
          Batch_Number: `PLS_${RequestNumber}_${FileDate}`,
          File_Timestamp: FileDate,
          File_Unix_Timestamp: ParsedDate.startOf("day").unix(),
        };
      }

      return null;
    },

    BeforeUpload(File) {
      const sName = String(File.name || "");
      const oParsed = this.ParseFilename(sName);

      if (!/\.xlsx$/i.test(sName)) {
        this.$message.error("Chỉ hỗ trợ file .xlsx");
        return false;
      }

      if (!oParsed) {
        this.$message.error(
          "Tên file không đúng định dạng hỗ trợ: VoucherCodes_<Batch_Number>_YYYYMMDD_HHmmss.xlsx hoặc Shopee_PLS_Request_<Number>_DDMMYYYY.xlsx",
        );
        return false;
      }

      this.Form.File = File;
      this.Form.File_Name = sName;
      this.Form.Batch_Number = oParsed.Batch_Number;
      this.Form.File_Timestamp = oParsed.File_Timestamp;
      this.Form.File_Unix_Timestamp = oParsed.File_Unix_Timestamp;
      this.FileList = [File];

      if (this.$refs.ImportForm) {
        this.$nextTick(() => {
          this.$refs.ImportForm.clearValidate("File");
        });
      }

      return false;
    },

    RemoveFile() {
      this.Form.File = null;
      this.Form.File_Name = "";
      this.Form.Batch_Number = "";
      this.Form.File_Timestamp = "";
      this.Form.File_Unix_Timestamp = "";
      this.FileList = [];
      return true;
    },

    ParseExpiredDate(Value) {
      const Text = String(Value || "").trim();

      if (!Text) {
        return null;
      }

      /*
       * Strict parse để tránh JS tự hiểu nhầm D/M thành M/D.
       * Hỗ trợ:
       * 1/1/2027
       * 2027-01-01
       * 2027/01/01
       * 1-1-2027
       */
      const Parsed = moment(
        Text,
        [
          "D/M/YYYY",
          "DD/MM/YYYY",
          "YYYY-M-D",
          "YYYY-MM-DD",
          "YYYY/M/D",
          "YYYY/MM/DD",
          "D-M-YYYY",
          "DD-MM-YYYY",
        ],
        true,
      );

      return Parsed.isValid()
        ? Parsed.startOf("day")
        : null;
    },

    NormalizeExpiredDate() {
      const Parsed = this.ParseExpiredDate(
        this.Form.Expired_Date,
      );

      if (!Parsed) {
        return;
      }

      /*
       * Sau khi người dùng nhập xong, chuẩn hóa hiển thị về DD/MM/YYYY.
       * Khi submit sẽ gửi chuẩn YYYY-MM-DD cho BE.
       */
      this.Form.Expired_Date =
        Parsed.format("DD/MM/YYYY");
    },

    DisablePastDate(Current) {
      return Current && Current < moment().startOf("day");
    },
    async SubmitImport() {
      this.$refs.ImportForm.validate(async (Valid) => {
        if (!Valid || this.Loading.Import) {
          return;
        }

        this.Loading.Import = true;

        this.Result = {
          State: null,
          Message: "",
          Failed: 0,
          Failed_Note: "",
        };

        try {
          const Data = new FormData();

          Data.append("File", this.Form.File);

          const ExpiredDate =
            this.ParseExpiredDate(
              this.Form.Expired_Date,
            );

          Data.append(
            "Expired_Date",
            ExpiredDate
              ? ExpiredDate.format("YYYY-MM-DD")
              : "",
          );

          Data.append("Password", this.Form.Password || "");

          Data.append("Value", String(this.Form.Value || ""));

          Data.append("Providor", this.Form.Providor || "");

          /*
           * $PostAPI:
           * - tự append Token vào FormData
           * - tự nối /crm/api
           * - mặc định trả res.data
           */
          const Result = await this.$PostAPI("/voucher-import/import", Data);

          const Summary =
            Result && Result.Data && Result.Data.Summary
              ? Result.Data.Summary
              : {};

          this.Result = {
            State: Result ? Result.State : 0,

            Message: Result && Result.Message ? Result.Message : "",

            Failed: Number(Summary.Failed || 0),

            Failed_Note: Summary.Failed_Note || "",
          };

          if (Result && Result.State === 1) {
            this.$message.success(Result.Message || "Import voucher hoàn tất.");

            this.History.Page = 1;

            await this.LoadHistory();
          } else {
            this.$message.error(
              Result && Result.Message
                ? Result.Message
                : "Import voucher thất bại.",
            );
          }
        } catch (Error) {
          console.log("Voucher-Import-Error:", Error);

          const Result =
            Error && Error.response && Error.response.data
              ? Error.response.data
              : null;

          this.Result = {
            State: 0,

            Message:
              Result && Result.Message
                ? Result.Message
                : "Không kết nối được API Import Voucher.",

            Failed: 0,

            Failed_Note:
              Result && Result.Data && Result.Data.Summary
                ? Result.Data.Summary.Failed_Note || ""
                : "",
          };

          this.$message.error(this.Result.Message);
        } finally {
          this.Loading.Import = false;
        }
      });
    },

    async LoadHistory() {
      if (this.Loading.History) {
        return;
      }

      this.Loading.History = true;

      try {
        const Response = await this.$PostAPI("/voucher-import/history", {
          Page: this.History.Page,
          PageSize: this.History.PageSize,
        });

        const Result = Response || {};

        if (Result.State !== 1) {
          this.$message.error(
            Result.Message || "Không tải được lịch sử import.",
          );
          return;
        }

        const Data = Result.Data || {};
        this.History.Items = Data.Items || [];
        this.History.Total = Number(Data.Total || 0);
        this.History.Page = Number(Data.Page || 1);
        this.History.PageSize = Number(Data.PageSize || 30);
      } catch (Error) {
        console.log(Error);
        this.$message.error("Không tải được lịch sử import voucher.");
      } finally {
        this.Loading.History = false;
      }
    },

    ChangePage(Page) {
      this.History.Page = Page;
      this.LoadHistory();
    },

    ChangePageSize(Page, PageSize) {
      this.History.Page = 1;
      this.History.PageSize = PageSize;
      this.LoadHistory();
    },

    async DownloadHistory(Record) {
      try {
        const Response = await axios.get(
          this.$PRJ_DOMAIN+"/crm/api/voucher-import/download/" + Record._id,
          {
            responseType: "blob",

            headers: {
              "X-CRM-Token": this.GetToken(),
            },
          },
        );

        const BlobData = new Blob([Response.data]);
        const URLObject = window.URL.createObjectURL(BlobData);
        const Link = document.createElement("a");
        Link.href = URLObject;
        Link.download = Record.Filename + ".xlsx";
        document.body.appendChild(Link);
        Link.click();
        document.body.removeChild(Link);
        window.URL.revokeObjectURL(URLObject);
      } catch (Error) {
        console.log(Error.message);
        this.$message.error("Không tải được file import gốc.");
      }
    },

    FormatMoney(Value) {
      return Number(Value || 0).toLocaleString("vi-VN");
    },

    FormatDate(Value) {
      return Value ? moment.utc(Value).format("DD/MM/YYYY") : "-";
    },

    FormatDateTime(Value) {
      return Value ? moment.utc(Value).format("DD/MM/YYYY HH:mm:ss") : "-";
    },
  },
};
</script>

<style scoped>
.import-card,
.history-card {
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.history-card {
  margin-top: 16px;
}

.import-form-grid {
  margin-top: 12px;
}

.file-panel,
.import-config-panel {
  height: 100%;
}

.file-panel {
  padding: 14px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fafafa;
}

.select-file-button {
  min-width: 190px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 80, 122, 0.18);
}

.file-help {
  max-width: 310px;
  font-size: 12px;
  line-height: 1.45;
}

.import-config-panel {
  padding: 10px 14px 2px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
}

.compact-form-item {
  margin-bottom: 10px;
}


.page-title,
.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #00507a;
}

.page-subtitle,
.section-subtitle,
.field-help {
  color: #8c8c8c;
  margin-top: 4px;
}

.result-alert {
  margin: 16px 0;
}

.filename-preview {
  padding: 12px 16px;
  margin-top: 4px;
  line-height: 1.8;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
}

.action-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.failed-note {
  display: inline-block;
  max-width: 270px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #cf1322;
}

.pagination-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
